import Main from './scripts';

(function() {
    Main().start();
})();